import routes from '../config/routes';

// Resolves React Router path for the header logo: doctor dashboard, patient calibration entry, or public root.
export function resolveLogoHomePath(accountType: string): string {
  const t = (accountType || '').toLowerCase();
  if (t === 'doctor') {
    return routes.doctor.defaultRoute;
  }
  if (t === 'patient') {
    return routes.patient.safeRoute;
  }
  return '/';
}

// Returns true when the current path is already the patient calibration home (or integration service route).
export function isLogoHomePath(pathname: string, homePath: string): boolean {
  if (homePath === routes.patient.safeRoute) {
    return pathname === '/calibration' || pathname.includes('/service/');
  }
  return pathname === homePath;
}
